import React from "react";
import {
  faCheckSquare,
  faMinusSquare,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from "react-bootstrap";


export default function CheckBoxCustom({ value = 0, onValue }) {
  return (
    <Button
      onClick={onValue}
      variant={value ? "success" : "danger"}
      size="sm"
      className="m-1"
    >
      <FontAwesomeIcon icon={value ? faCheckSquare : faMinusSquare} />
    </Button>
  );
}
